import React, { useRef, useMemo } from 'react'

import { SidePanelModal } from '~/components/SidePanelModal'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { useManageDrawerColumns } from '../hooks/useManageDrawerColumns'
import { DrawerContent } from './DrawerContent/DrawerContent'

const Drawer: React.FC<DrawerProps> = ({
  columns,
  isOpen,
  onClose,
  onColumnsChange,
  onResetToDefault,
  className
}) => {
  const { t } = useAPPTranslation()
  const messageId = useRef('column-selector-drawer')
  const {
    isPortalReady,
    hasSelectableColumns,
    bulkSelectionLabelKey,
    visibleColumnsLabel,
    handleToggleAllColumns,
    handleToggleColumn
  } = useManageDrawerColumns({
    columns,
    onColumnsChange
  })

  const drawerContentProps: DrawerContentProps = useMemo(
    () => ({
      className,
      columns,
      visibleColumnsLabel,
      hasSelectableColumns,
      handleToggleAllColumns,
      handleToggleColumn,
      bulkSelectionLabelKey,
      onResetToDefault
    }),
    [
      className,
      columns,
      visibleColumnsLabel,
      hasSelectableColumns,
      handleToggleAllColumns,
      handleToggleColumn,
      bulkSelectionLabelKey,
      onResetToDefault
    ]
  )

  const message = useMemo<SidePanelMessage>(
    () => ({
      id: messageId.current,
      title: t('c:components.ColumnSelector.columns'),
      size: 'fluid',
      content: <DrawerContent {...drawerContentProps} />
    }),
    [t, drawerContentProps]
  )

  if (!isOpen || !isPortalReady) {
    return null
  }

  return <SidePanelModal message={message} onClose={onClose} />
}

export default Drawer
